<template>
  <StepData
    :transaction
    :asset
  >
    <template #start>
      <div class="private-fund-investment">
        <UIYesNoSwitch
          v-model="isNoDrawdown"
          label="Drawdown?"
          variant="secondary"
          reverse
          :size
        />
        <component
          :is="transaction.getFormAmount2()"
          v-if="!isNoDrawdown && transaction"
          label="Commitment"
          :instance="transaction"
          :size
          hide-sign
          trail-currency
        />
      </div>
    </template>
    <template #amount>
      <span />
    </template>
  </StepData>
</template>

<script setup lang="ts">
import { AssetClass, InputSize, TransactionClass } from '@types'

import StepData from '../modules/StepData.vue'
import { UIYesNoSwitch } from '@ui/controllers'
import { inject } from 'vue'

type Props = {
  transaction?: TransactionClass
  asset: AssetClass
}

defineProps<Props>()

defineOptions({ inheritAttrs: false })

const isNoDrawdown = defineModel<boolean>('isNoDrawdown', { required: true })

const size = inject<InputSize>('size')
</script>

<style>
.private-fund-investment {
  @apply grid sm:grid-cols-[1fr_1.3fr];
  @apply gap-4;
}
</style>
